import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { getRoamingDetailsByIdentifier } from "../../../store/devices/logicalDevices";
import { isAssignActionDisabled } from "../../../store/profiles/profiles.selectors";
import { Icon } from "../../icon/Icon";
import { openAssignRoamingModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useAssignRoamingDeviceMenuItem = (identifier) => {
  const dispatch = useDispatch();
  const device = useSelector(
    (state) => getRoamingDetailsByIdentifier(state, identifier),
    _.isEqual
  );
  const isActionDisabled = useSelector((state) =>
    isAssignActionDisabled(state, device.profile)
  );

  return {
    id: "assign",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-plus" />
        <span>
          <FormattedMessage id="assign_to_group" />
        </span>
      </Fragment>
    ),
    disabled: isActionDisabled,
    action: () => dispatch(openAssignRoamingModal(device)),
  };
};

export const AssignRoamingDeviceDropdownItem = ({ identifier, ...props }) => {
  const { id, content, disabled, action } =
    useAssignRoamingDeviceMenuItem(identifier);

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const AssignRoamingDeviceModalItem = ({ identifier }) => {
  const { id, content, disabled, action } =
    useAssignRoamingDeviceMenuItem(identifier);

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
